import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { forwardRef, RefObject } from 'react'

export interface PillOptionVariantProps {
  label: string
  onClick: (
    e: React.MouseEvent<HTMLLabelElement | HTMLButtonElement, MouseEvent>,
  ) => void
  disabled?: boolean
  selected?: boolean
  role?: 'checkbox' | 'radio' | 'switch'
  children?: React.ReactNode
}

export const PillOptionVariant = forwardRef<
  HTMLLabelElement | HTMLButtonElement,
  PillOptionVariantProps
>((props, ref) => {
  const forwardedRef = ref as RefObject<HTMLButtonElement>

  return (
    <button
      type='button'
      disabled={props.disabled}
      ref={forwardedRef}
      onFocus={() => forwardedRef?.current?.focus()}
      tabIndex={0}
      role={props.role ?? 'checkbox'}
      aria-disabled={props.disabled}
      aria-checked={props.selected}
      onClick={props.onClick}
      className={`px-3 py-1.5 whitespace-nowrap rounded-full text-sm border transition-colors flex items-center gap-2 ${
        props.selected
          ? 'bg-primary-500 text-white border-primary-500'
          : 'bg-white text-base-600 border-base-300 hover:border-primary-400'
      }`}>
      {props.selected && (
        <FontAwesomeIcon className='text-white' icon={faCheck} />
      )}
      <span className='min-w-fit'>
        {props.children ? props.children : props.label}
      </span>
    </button>
  )
})
